<gl-checkbox
  [id]="rowId || checkboxQuestion.key"
  small
  [skeletorValueAccessor]="checkboxQuestion"
  [checked]="checkboxQuestion.value"
></gl-checkbox>
